/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-home': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<path pid="0" d="M13.633 6.348L7.683.623a1.149 1.149 0 00-1.542 0L.19 6.348a.575.575 0 10.77.854l5.952-5.725 5.95 5.725a.575.575 0 10.771-.853zm-1.59 2.123a.575.575 0 00-.575.576v4.43H9.182V9.637a1.15 1.15 0 00-1.151-1.15H5.792a1.15 1.15 0 00-1.151 1.151v3.837H2.355v-4.43a.576.576 0 00-1.152 0v4.43c0 .636.515 1.151 1.152 1.151h9.113a1.15 1.15 0 001.152-1.149V9.046a.575.575 0 00-.576-.575zM5.794 9.64H8.03v3.837H5.792V9.639z" _fill="#595959" fill-rule="nonzero"/>'
  }
})
